// export const Currency_Converter_API_URL = "http://192.168.0.109:3019/api/v1/"
// export const Uganda_Lugazi_IMG_API_URL = "http://192.168.0.109:3019/"

export const Currency_Converter_API_URL = "https://bookyourforex.in/ForexAPI/api/v1/"
export const Uganda_Lugazi_IMG_API_URL = "https://bookyourforex.in/ForexAPI/"

// export const Uganda_Lugazi_API_URL = "http://ugandalugazi.smtonline.in/LugaziAPI/api/v1/";
// export const Uganda_Lugazi_IMG_API_URL = "http://ugandalugazi.smtonline.in/LugaziAPI/";

export const MAP_API_KEY = "AIzaSyA8Io_sD3d5uTz6ZTj4FKae_I7mdBVjX9o";
export const SUPPORTED_IMAGE_FORMATS = ["image/jpeg", "image/png", "image/jpg"];
export const MAX_IMAGE_SIZE = 1 * 1024 * 1024;
